import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

const sendBrevoMailCallable = httpsCallable(functions, "sendBrevoMail");

export function sendBrevoMail(emailData) {
  return sendBrevoMailCallable({
    ...emailData,
    site: process.env.REACT_APP_SITE_ENV || process.env.REACT_APP_SITE_NAME || "hoyerswerda",
  });
}